<script>
const routes = [
	{
		path: "/",
		component: () =>
			import(/* webpackChunkName: "home" */ "@/views/AppHome"),
		name: "home-ar"
	},
	{
		path: "/ar",
		// component: () => import(  /* webpackChunkName: "home-ar" */ "@/views/AppHome"),
		redirect: "/"
	},
	{
		path: "/new-appointment/:patientId?",
		component: () =>
			import(
				/* webpackChunkName: "new-appointment" */ "@/views/AppNewAppointment"
			)
	},
	{
		path: "/eye-doc",
		component: () =>
			import(/* webpackChunkName: "eye-doc" */ "@/views/AppEyeDoc")
	},
	{
		path: "/patient/:patientId?",
		component: () =>
			import(
				/* webpackChunkName: "new-patient" */ "@/views/AppNewPatient"
			)
	},
	{
		path: "/patient-update/:patientId",
		component: () =>
			import(
				/* webpackChunkName: "patient-update" */ "@/views/AppPatientUpdate"
			)
	},
	{
		path: "/patient-med-info/:appointmentId",
		component: () =>
			import(
				/* webpackChunkName: "patient-med-info" */ "@/views/AppPatientMedInfo"
			)
	},
	{
		path: "/report/:appointmentId",
		component: () =>
			import(/* webpackChunkName: "report" */ "@/views/AppReport")
	},
	{
		path: "/grading/:appointmentId",
		name: "grading",
		component: () =>
			import(/* webpackChunkName: "grading" */ "@/views/AppGrading")
	},
	{
		path: "/patient-profile/:patientId",
		component: () =>
			import(
				/* webpackChunkName: "patient-profile" */ "@/views/AppPatientProfile"
			)
	},
	{
		path: "/dashboard/home",
		component: () =>
			import(
				/* webpackChunkName: "dashboard-home" */ "@/views/dashboard/AppHome"
			)
	},
	{
		path: "/dashboard/clinic-info/:clinicId?",
		component: () =>
			import(
				/* webpackChunkName: "dashboard-clinic-info" */ "@/views/dashboard/AppClinicInfo"
			)
	},
	{
		path: "/dashboard/users",
		component: () =>
			import(
				/* webpackChunkName: "dashboard-users" */ "@/views/dashboard/AppUsers"
			)
	},
	{
		path: "/dashboard/stages-states",
		component: () =>
			import(
				/* webpackChunkName: "dashboard-stages-states" */ "@/views/dashboard/AppStagesStates"
			)
	},
	{
		path: "/dashboard/new-user",
		component: () =>
			import(
				/* webpackChunkName: "dashboard-user-new" */ "@/views/dashboard/AppUserNew"
			)
	},
	{
		path: "/dashboard/diagnosis-questions",
		component: () =>
			import(
				/* webpackChunkName: "dashboard-diagnosis-questions" */ "@/views/dashboard/AppDiagnosisQuestions"
			)
	},
	{
		path: "/dashboard/modify-user/:patientId?",
		component: () =>
			import(
				/* webpackChunkName: "dashboard-user-modify" */ "@/views/dashboard/AppUserModify"
			)
	},
	{
		path: "/dashboard/my-profile",
		component: () =>
			import(
				/* webpackChunkName: "dashboard-my-profile" */ "@/views/dashboard/AppMyProfile"
			)
	},
	{
		path: "/dashboard/my-profile/modify",
		component: () =>
			import(
				/* webpackChunkName: "dashboard-my-profile-modify" */ "@/views/dashboard/AppMyProfileModify"
			)
	},
	{
		path: "/dashboard/nationalities",
		component: () =>
			import(
				/* webpackChunkName: "dashboard-nationalities" */ "@/views/dashboard/AppNationalities"
			)
	},
	{
		path: "/dashboard/user-groups",
		component: () =>
			import(
				/* webpackChunkName: "dashboard-user-groups" */ "@/views/dashboard/AppUserGroups"
			)
	},
	{
		path: "/dashboard/sms",
		component: () =>
			import(
				/* webpackChunkName: "dashboard-sms" */ "@/views/dashboard/AppSMS"
			)
	},
	{
		path: "/dashboard/stat",
		component: () =>
			import(
				/* webpackChunkName: "dashboard-stat" */ "@/views/dashboard/AppStat"
			)
	},
	{
		path: "/dashboard/stat/users",
		component: () =>
			import(
				/* webpackChunkName: "dashboard-stat-users" */ "@/views/dashboard/stat/AppUsers"
			)
	},
	{
		path: "/dashboard/stat/eye-specialists",
		component: () =>
			import(
				/* webpackChunkName: "dashboard-stat-eye-specialists" */ "@/views/dashboard/stat/AppEyeSpecialists"
			)
	},
	{
		path: "/dashboard/stat/reports",
		component: () =>
			import(
				/* webpackChunkName: "dashboard-stat-reports" */ "@/views/dashboard/stat/AppReports"
			)
	},
	{
		path: "/dashboard/stat/appointments",
		component: () =>
			import(
				/* webpackChunkName: "dashboard-stat-appointments" */ "@/views/dashboard/stat/AppAppointments"
			)
	},
	{
		path: "/dashboard/stat/patients",
		component: () =>
			import(
				/* webpackChunkName: "dashboard-stat-patients" */ "@/views/dashboard/stat/AppPatients"
			)
	}
];

export default routes;
</script>
